import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static targets = ["nextPageLink", "items"]

  connect() {
    this.masonryReady = false
    this.element.addEventListener("masonry:ready", () => {
      this.masonryReady = true
      this.observeLastItem()
    })
  }

  async observeLastItem() {
    if (!this.masonryReady || !this.hasNextPageLinkTarget) return

    const lastItem = this.itemsTargets[this.itemsTargets.length - 1]
    if (!lastItem) return

    await nextIntersection(lastItem)
    await this.getNextPage()

    await delay(500) // Wait for 500 ms
    this.observeLastItem() // repeat the whole process!
  }

  async getNextPage() {
    if (!this.nextPageLinkTarget) return
    const nextPageUrl = this.nextPageLinkTarget.dataset.nextUrl
    if (!nextPageUrl) return

    try {
      const response = await get(nextPageUrl)
      const html = await response.text
      const doc = new DOMParser().parseFromString(html, "text/html")
      const newItems = doc.querySelectorAll(`[data-pagination-target="items"]`)
      const newPagination = doc.querySelector(`[data-pagination-target="nextPageLink"]`)

      newItems.forEach(item => {
        this.element.insertBefore(item, this.nextPageLinkTarget)
        // Trigger masonry layout update
        this.dispatch("itemAdded", { target: item })
      })

      if (newPagination) {
        this.nextPageLinkTarget.replaceWith(newPagination)
      } else {
        this.nextPageLinkTarget.remove()
      }

      // Trigger masonry layout update after all items are added
      this.dispatch("layout")
    } catch (error) {
      console.error("Error fetching next page:", error)
    }
  }
}

const delay = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

const nextIntersection = (targetElement) => {
  return new Promise(resolve => {
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) resolve()
    }, { rootMargin: "100px" }).observe(targetElement)
  })
} 